import React from 'react'
import ModelContext from '../contexts/ModelContext'
import { getMapValue } from '@morningtrain/react-helpers'
import isArray from 'lodash/isArray'
import { Env } from '@morningtrain/helpers'

export default function useParameterDecoder () {
  const model = React.useContext(ModelContext)

  function resolveDataSource (dataType, extraData = {}) {
    if (extraData && extraData[dataType]) {
      return extraData[dataType]
    }

    if (dataType === 'model') {
      return model
    }

    if (dataType === 'env') {
      return Env.data
    }

    return null
  }

  const decodeParameter = (parameter, extraData = {}) => {
    if (isArray(parameter)) {
      const values = []

      parameter.forEach(value => {
        values.push(decodeParameter(value))
      })

      return values
    }

    if (typeof parameter !== 'string') return parameter

    if (parameter.includes(':')) {
      const frags = parameter.split(':')
      const dataType = frags[0]
      let parameterKey = frags[1]

      let defaultValue = null

      if (parameterKey.includes('|')) {
        const fragments = parameterKey.split('|')
        parameterKey = fragments[0]
        defaultValue = fragments[1]
      }

      const dataSource = resolveDataSource(dataType, extraData)

      if (!dataSource) {
        return parameter
      }

      return getMapValue(dataSource, parameterKey, defaultValue)
    }

    return parameter
  }

  const decoder = (parameters = {}, extraData = {}) => {
    const decodedParameters = {}
    const parameterKeys = Object.keys(parameters || {})

    if (parameterKeys.length > 0) {
      Object.keys(parameters).forEach(key => {
        decodedParameters[key] = decodeParameter(parameters[key], extraData)
      })
    }

    return decodedParameters
  }

  return decoder
}
